import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Form, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import ClientService from '../../services/client.service';
import LoginAuth from '../../services/auth.service';
import logo from "../../assets/images/adm_logo.png";
import smalllogo from "../../assets/images/adm_logo_small.png";
import {  dashboardIcon, documentIcon, dragIcon, chatIcon, billingIcon, fileIcon, companydataIcon, } from '../../utils/icons'; 

import { setClient } from '../../feature/client.slice';


const Sidebar = ({ isCollapsed, toggleSidebar,resetSelectedThread  }) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [activeItem, setActiveItem] = useState('dashboard');
  const [show, setShow] = useState(false);
  // const [userId, setUserId] = useState('');
  const [clientDetails, setClientDetails] = useState([]);
  // console.log(clientDetails)
  const [mainDetails, setMainDetails] = useState([]);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const logout = async () => {
    try { await LoginAuth.logout(); } catch (e) { /* log out locally regardless */ }
    navigate('/login', { replace: true });
  };
  const pathArray = window.location.pathname.split('/');
  const id = pathArray[pathArray.length - 1];



  const handleItemClick = (item) => {
   
    setActiveItem(item)
  if(item=="taskandchats" && resetSelectedThread ){
    resetSelectedThread() 
  }
  
  };
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCheckboxChange = (clientId) => {
    const selectedClient = clientDetails.find(client => client.id === clientId);
    setMainDetails(selectedClient);

  };

  useEffect(() => {
    // Update the active item based on the current location
    const pathArray = location.pathname.split('/');
    const currentPath = pathArray[pathArray.length - 1];
    setActiveItem(currentPath);
  }, [location.pathname]);

 
  const navItems = [

    { name: 'Dashboard', path: `/dashboard`, key: 'dashboard', imageicon: dashboardIcon },
    { name: 'Documents', path: '/documents',  key: 'documents', imageicon: fileIcon },
    { name: 'Tasks', path: '/tasks',  key: 'tasks', imageicon: documentIcon },
    { name: 'Chats', path: '/chats',  key: 'taskandchats', imageicon: chatIcon },
    { name: 'Company Data', path: '/CompanyData',  key: 'CompanyData', imageicon: companydataIcon },
    // { name: 'Billing', path: '/BillingCustom',  key: 'BillingCustom', imageicon: billingIcon }

  ];

  const handleToggleSidebar = () => {
    toggleSidebar(!isCollapsed);
    localStorage.setItem('sidebarState', !isCollapsed ? 'collapsed' : 'expanded');
  };

  return (
    <>
  <div className={`side-bar ${isCollapsed ? 'collapsed' : 'expanded'}`}>
        <div className='logo-container'>
          <div className='logo-block'>
            <a className='logo' href="/" ><img src={isCollapsed ? smalllogo : logo} alt="ADM One" /></a>
            {/* Names the business behind the portal (also what SMS consent is given to). */}
            {!isCollapsed && <div className='logo-byline'>by ADM CPA P.C.</div>}
          </div>
          <div className={`toggle-icon ${isCollapsed ? 'collapsed' : ''}`}> 
            <img src={dragIcon} onClick={handleToggleSidebar} />
          </div>
        </div>
        <nav>
          <ul>
            {navItems.map(item => (
              <li key={item.key}>
                <Link
                  to={item.path}
                  className={`link-list ${location.pathname.includes(item.path) ? 'active' : ''}`}
                  onClick={() => handleItemClick(item.key)}
                >
                  <div className='icon-label'>
                    <img
                      src={item.imageicon}
                      width="20"
                      height="20"
                      className="icon"
                    />
                    {!isCollapsed && <span className="nav-link">{item.name}</span>}
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* Pinned to the bottom: the sidebar is a flex column. */}
        <nav className="mt-auto">
          <ul style={{ paddingTop: 0, paddingBottom: '1rem' }}>
            <li>
              <button
                type="button"
                className="link-list w-100 bg-transparent"
                onClick={logout}
                title="Logout"
              >
                <div className='icon-label'>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                       strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="icon" aria-hidden="true">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                    <path d="M16 17l5-5-5-5" /><path d="M21 12H9" />
                  </svg>
                  {!isCollapsed && <span className="nav-link">Logout</span>}
                </div>
              </button>
            </li>
          </ul>
        </nav>
      </div>
     
      {/* BOOTSTRAP MODAL */}
      <Modal show={show} onHide={handleClose} animation={true}>
        <Modal.Header closeButton>
          <Modal.Title>Choose Company</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="SwitchCompany_wrapper p-2">
            {clientDetails && clientDetails.map((clientDetails) => (
              <div className="mb-4" key={clientDetails.id}>
                <div className="d-flex justify-content-between align-items-top">
                  <div className='d-flex'>
                    <div className='me-3'>
                      <img src={logo} alt="" className="w-100" />
                    </div>
                    <div>
                      <p className="card-title m-0 text-black fw-semibold">{clientDetails.name}</p>
                      <p className="card-text text-black" style={{ fontSize: "14px" }}>
                        {clientDetails.address_line_1}, {clientDetails.zip}<br />{clientDetails.email}
                      </p>
                    </div>
                  </div>
                  <Form.Check type="radio" id={`css1_${clientDetails.id}`} name="fav_language" value="CSS" onChange={() => handleCheckboxChange(clientDetails.id)} />
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Sidebar;
